import dayjs from 'dayjs';

/**
 * [getRemainingOfferDuration]
 * Calculate the remaining duration given the offer start time and duration
 *
 * @param  {dayjs.Dayjs} offerStartTime
 * @param  {number} offerDuration
 * @returns {Object} Remaining offer duration Date and whether the offer expired or not
 */
export const getRemainingOfferDuration = (offerStartTime: dayjs.Dayjs, offerDuration: number) => {
  // How many milliseconds have passed since the offer start to now?
  const timePassedFromOfferStart = dayjs().diff(dayjs(offerStartTime));
  // To calculate remaining, add original duration and subtract time passed
  const remainingOfferDuration = dayjs()
    .add(offerDuration, 'h')
    .subtract(timePassedFromOfferStart, 'millisecond');

  const isOfferExpired = remainingOfferDuration.isBefore(dayjs());

  return { remainingOfferDuration: remainingOfferDuration.toDate(), isOfferExpired };
};
